export const PROFILE_SIDEBAR_MENU_ITEMS = {
    PREFERENCE_CENTER: 'PREFERENCE_CENTER',
    NOTIFICATION_SETTINGS: 'NOTIFICATION_SETTINGS',
    LANGUAGE_SELECT: 'LANGUAGE_SELECT',
    CONTACT_US: 'CONTACT_US',
    TERMS_OF_USE: 'TERMS_OF_USE',
    PRIVACY_NOTICE: 'PRIVACY_NOTICE',
    ATTRIBUTION_NOTICE: 'ATTRIBUTION_NOTICE',
};
